module.exports = __webpack_public_path__ + "img/Kraftfahrzeug_geländegängig.49b16856.svg";